<n-header class="assistant-title">
    <!-- 标题 -->
    <app-smart-assistant-switch class="assistant-title-font" [content]="i18n.smartAssistantTitle" [isTitle]="true"></app-smart-assistant-switch>
    <!-- 关闭按钮 -->
    <button class="icon-btn" id="smart-assistant-close-btn" (click)="hide()">
        <svg class="icon icon-simple">
            <use xlink:href="#icon-close"></use>
        </svg>
    </button>
</n-header>

<div class="assistant-body">
    <!-- 选择引导场景 -->
    <ng-container *ngIf="!showStorageResGuide && (hasGuidePermission || hasFsPermission)">
        <!-- 未完成的进程 -->
        <div *ngIf="hasUnfinishedProcess && hasGuidePermission && !showExportLog" id="smart-assistant-unfinished-process-card"
            class="continue-card">
            <div class="continue-card-tip" style="font-size: 14px;" id="smart-assistant-unfinished-process-continuetip">
                <svg class="continue-card-tip-icon">
                    <use xlink:href="#core-icon-simple-status-info"></use>
                </svg>
                <span class="ml-8">{{i18n.continueTip}}</span>
            </div>
            <div class="continue-card-content">
                <!-- 类型 -->
                <div id="smart-assistant-unfinished-process-process-type">{{processType}}</div>
                <!-- 时间 -->
                <div id="smart-assistant-unfinished-process-process-starttime" class="sub">{{processStartTime}}</div>
                <!-- 步骤条 -->
                <div class="flex-style" style="margin-top: 0.08rem;">
                    <ng-container *ngFor="let item of str.stepItems; index as i">
                        <!-- 点 -->
                        <div class="continue-card-content-dot"
                            [ngStyle]="{'background': i <= processStep ? '#2673e5' : '#cccccc'}">
                        </div>
                        <!-- 连接线 -->
                        <div class="continue-card-content-line" *ngIf="i < str.stepItems.length - 1"
                            [ngStyle]="{'background': i < processStep ? '#2673e5' : '#cccccc'}">
                        </div>
                    </ng-container>
                </div>
                <div class="continue-card-content-btn mt-16">
                    <!-- 结束按钮 -->
                    <button id="smart-assistant-continue-end-btn"
                        nButton theme="text" [label]="i18n.endProcessBtn"
                        (click)="endProcess()">
                    </button>
                    <!-- 继续按钮 -->
                    <button id="smart-assistant-continue-continue-btn"
                        nButton theme="text" [label]="i18n.continueProcessBtn"
                        (click)="jumpToGuide()">
                    </button>
                </div>
            </div>
            <n-loading [visible]="showLoading"></n-loading>
        </div>

        <!-- 选择应用类型 -->
        <ng-container *ngIf="ENTRY_CHECK_LIST.block.includes(entry) || showHome">
            <app-smart-assistant-switch *ngIf="hasGuidePermission || (hasFsPermission && (SHOW_HOME_ENTRY.includes(entry) || showHome))"
                class="mt-15" [content]="topTipContent" [showIcon]="false">
            </app-smart-assistant-switch>
            <!-- 按场景/应用 -->
            <ng-container *ngIf="hasGuidePermission && supportSmartThin">
                <div class="mt-16 operate-type">{{i18n.scenarioAndApplication}}</div>
                <div *ngFor="let item of str.applicationOperate; let i = index"
                    [id]="'smart-assistant-application-operate-' + i"
                    class="operate-item flex-style mt-10"
                    (click)="jumpToGuide(item.type)">
                    <svg class="operate-item-icon">
                        <use [attr.xlink:href]="item.icon"></use>
                    </svg>
                    <span>{{item.name}}</span>
                </div>
            </ng-container>

            <!-- 按数据类型 -->
            <div *ngIf="hasGuidePermission || (hasFsPermission && (SHOW_HOME_ENTRY.includes(entry) || showHome))"
                class="mt-25 operate-type">
                {{i18n.byDataType}}
            </div>
            <!-- 块存储 -->
            <ng-container *ngIf="hasGuidePermission && supportSmartThin">
                <div *ngFor="let item of str.dataType"
                    [id]="'smart-assistant-data-type-' + i"
                    class="operate-item flex-style mt-8"
                    (click)="jumpToGuide(item.type)">
                    <svg class="operate-item-icon">
                        <use [attr.xlink:href]="item.icon"></use>
                    </svg>
                    <span>{{item.name}}</span>
                </div>
            </ng-container>
            <!-- 文件服务 -->
            <div *ngIf="hasFsPermission && (SHOW_HOME_ENTRY.includes(entry) || showHome)"
                id="smart-assistant-data-type-file-system"
                class="operate-item flex-style mt-10"
                (click)="createFileSystem()">
                <svg class="operate-item-icon">
                    <use [attr.xlink:href]="'#app-icon-simple-file-system'"></use>
                </svg>
                <span>{{i18n.fileSystemTitle}}</span>
            </div>
            <hr class="smart-assistant-home-line" *ngIf="SHOW_HOME_ENTRY.includes(entry) || showHome" style="margin-top: 16px;">
        </ng-container>
    </ng-container>

    <!-- LUN/主机/启动器/映射引导页面 -->
    <app-storage-resources-guidance *ngIf="showStorageResGuide && hasGuidePermission && entry === SmartAssistantEntryE.Block"
        (goBack)="backToHome()">
    </app-storage-resources-guidance>

    <!-- 文件共享（首页不显示动图） -->
    <ng-container *ngIf="ENTRY_CHECK_LIST.fileShare.includes(entry) || showHome">
        <app-smart-assistant-file-share [showImage]="!SHOW_HOME_ENTRY.includes(entry) && !showHome"
            [maxHeight]="fileShareExpand ? MAX_HEIGHT.normal : MAX_HEIGHT.fileShare + 'px'">
        </app-smart-assistant-file-share>
        <div class="drop-down" *ngIf="(SHOW_HOME_ENTRY.includes(entry) || showHome) && (fileShare?.nfsDatas.length !== 0 || fileShare?.cifsDatas.length !== 0)">
            <!-- 下拉按钮 -->
            <button nButton icon="app-icon-simple-arrow-down" class="drop-down-btn"
                *ngIf="fileShare?.el?.nativeElement.offsetHeight >= MAX_HEIGHT.fileShare"
                [style.transform]="fileShareExpand ? 'rotateX(180deg)' : 'rotateX(0deg)'"
                [border]="false" (click)="changeExpand(SmartAssistantEntryE.FileShare)">
            </button>
            <!-- 分割线 -->
            <hr class="smart-assistant-home-line">
        </div>
    </ng-container>

    <!-- 数据保护（首页不显示动图） -->
    <ng-container *ngIf="ENTRY_CHECK_LIST.protection.includes(entry) || showHome">
        <app-smart-assistant-object-protection  [showImage]="!SHOW_HOME_ENTRY.includes(entry) && !showHome"
            [maxHeight]="protectionExpand ? MAX_HEIGHT.normal : MAX_HEIGHT.protection + 'px'">
        </app-smart-assistant-object-protection>
        <div class="drop-down" *ngIf="(SHOW_HOME_ENTRY.includes(entry) || showHome) && (protection?.lunDatas.length !== 0 || protection?.fsDatas.length !== 0)">
            <!-- 下拉按钮 -->
            <button nButton icon="app-icon-simple-arrow-down" class="drop-down-btn"
                *ngIf="protection?.el?.nativeElement.offsetHeight >= MAX_HEIGHT.protection"
                [style.transform]="protectionExpand ? 'rotateX(180deg)' : 'rotateX(0deg)'"
                [border]="false" (click)="changeExpand(SmartAssistantEntryE.ObjectProtection)">
            </button>
            <!-- 分割线 -->
            <hr class="smart-assistant-home-line">
        </div>
    </ng-container>

    <!-- 告警 -->
    <ng-container *ngIf="(ENTRY_CHECK_LIST.alarms.includes(entry) || showHome) && !showExportLog">
        <app-smart-assistant-alarms [showAll]="!SHOW_HOME_ENTRY.includes(entry) && !showHome"
            [maxHeight]="alarmExpand ? MAX_HEIGHT.normal : MAX_HEIGHT.alarm + 'px'">
        </app-smart-assistant-alarms>
        <!-- 分割线 -->
        <div class="drop-down" *ngIf="(SHOW_HOME_ENTRY.includes(entry) || showHome) && alarmEl?.data.recent.length !== 0">
            <!-- 下拉按钮 -->
            <button nButton icon="app-icon-simple-arrow-down" class="drop-down-btn"
                *ngIf="alarmEl?.el?.nativeElement.offsetHeight >= MAX_HEIGHT.alarm"
                [style.transform]="alarmExpand ? 'rotateX(180deg)' : 'rotateX(0deg)'"
                [border]="false" (click)="changeExpand(SmartAssistantEntryE.AlarmAndEvent)">
            </button>
            <!-- 分割线 -->
            <hr class="smart-assistant-home-line">
        </div>
    </ng-container>

    <!-- 导出日志 -->
    <app-export-simple *ngIf="showExportLog"
        #exportSimple class="export-container">
    </app-export-simple>

    <!-- 导出报告 -->
    <app-smart-assistant-report *ngIf="ENTRY_CHECK_LIST.report.includes(entry) || showHome"></app-smart-assistant-report>
</div>
